module.exports = __webpack_public_path__ + "static/media/Jynx_gaussian2.b5a45389.png";